import { atom } from 'recoil';

export const healthBenefitState = atom({
  key: 'health_benefit_state',
  default: {
    items: [],
    desc: false,
    order_by: 'driver_id',
    total: null,
    sum_payout_amount: null,
    size: 20,
    page: 1,
    screen: null,
    search_text: '',
    status: '',
    is_dsp_driver: '',
    years: [],
    quarters: [],
    enabled: '',
    activated: '',
    isListing: false,
    total_driving_time: null,
    total_driving_distance: null,
  },
});

export const healthBenefitPaymentRequestState = atom({
  key: 'health_benefit_payment_request_state',
  default: {
    items: [],
    desc: false,
    order_by: 'driver_id',
    total: null,
    size: 20,
    page: 1,
    screen: null,
    search_text: '',
    status: '',
    total_driver: 0,
    sum_payout_amount: 0,
    years: [],
    quarters: [],
    isListing: false,
  },
});
